export default __webpack_public_path__ + "static/media/warning-icon.6f69762f.svg";